<template>
<main>
    <div class="wrapper">
      <div class="conversations-wrapper" :class="!showConversation? 'hide-conversations': 'animated slideIn slow'">
        <top-bar v-if="showTopbar && newConversationUser" :user="newConversationUser" @onOpenConversations="onOpenConversations" class="is-hidden-tablet"/>
        <top-bar v-else-if="showTopbar" :conversation="currentConversation" @onOpenConversations="onOpenConversations" class="is-hidden-tablet" />
        <conversations />
      </div>
      <div class="detail-wrapper" v-if="currentConversation" :class="[currentConversation? 'show-conversation': '', showConversation ? 'is-hidden-box' : '']">
        <top-bar :conversation="currentConversation" @onOpenConversations="onOpenConversations" />
        <message-view :messages="messages"
          :conversation="currentConversation" />
        <input-bar class="input-bar" :text.sync="messageText" v-on:submit="submit" />
      </div>
      <div class="detail-wrapper" v-if="newConversationUser" :class="[newConversationUser? 'show-conversation': '', showConversation ? 'is-hidden-box' : '']">
        <top-bar :user="newConversationUser" @onOpenConversations="onOpenConversations" />
        <input-bar class="input-bar" :text.sync="messageText" v-on:submit="submit" />
      </div>
      <div class="detail-wrapper no-messages" v-if="showEmptyState">
        <empty-state title="No Messages" icon="empty-state-message">
          <template slot="content">
            <p class="text">{{$t('messages.noMessagesDesc')}}</p>
          </template>
        </empty-state>
      </div>
    </div>
</main>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import Conversations from '../../components/messaging/conversations'
import TopBar from '@/components/messaging/conversation-top-bar'
import MessageView from '@/components/messaging/messages-view'
import InputBar from '@/components/messaging/input-bar'
import EmptyState from '@/components/general/empty-state'

export default {
  components: { Conversations, MessageView, TopBar, InputBar, EmptyState },
  computed: {
    conversationId () {
      return this.$route.params.id
    },
    showEmptyState () {
      return this.conversations && this.conversations.length === 0 && !this.newConversationUser
    },
    ...mapState('conversations', [
      'conversations',
      'currentConversation',
      'messages',
      'newConversationUser'
    ])
  },
  methods: {
    ...mapActions('conversations', [
      'getConversation',
      'sendMessageToUser',
      'sendMessage'
    ]),
    ...mapMutations('conversations', [
      'resetNewConversationUser',
      'resetCurrentConversation'
    ]),
    update () {
      this.$store.commit('conversations/setMessages', [])
      if (this.conversationId) {
        this.showConversation = false
        this.getConversation(this.conversationId)
      }
      if (this.newConversationUser) {
        this.showConversation = false
      }
    },
    onOpenConversations () {
      this.showConversation = !this.showConversation
      this.showTopbar = this.showConversation
    },
    async submit () {
      if (!this.messageText) { return }

      const content = this.messageText

      if (this.currentConversation) {
        await this.sendMessage({
          content
        })
      } else if (this.newConversationUser) {
        await this.sendMessageToUser({
          content, userId: this.newConversationUser.id
        })
        this.$router.push(`/messages/${this.currentConversation.id}`)
      }

      this.messageText = ''
    }
  },
  watch: {
    $route () {
      this.update()
    }
  },
  mounted () {
    this.update()
  },
  beforeDestroy () {
    this.resetNewConversationUser()
    this.resetCurrentConversation()
    this.showConversation = true
  },
  data () {
    return {
      messageText: '',
      showConversation: true,
      showTopbar: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';
iframe#intercom-frame {
  bottom: 0px !important;
}
main {
  margin-top: -1.5rem;
}

.wrapper {
  display: flex;
}

.detail-wrapper {
  width: 100%;
  height: 100vh;
  max-height: 100vh;
  display: flex;
  flex-direction: column;
  margin-bottom: -1rem;
  justify-content: space-between;
  position: relative;
}
.detail-wrapper .empty-state {
  margin: 16px;
}
.input-bar {
  z-index: 10000000000;
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 5.2rem !important;
  min-height: 5.2rem !important;
}
@media screen and (max-width: $tablet) {
    .is-hidden-box {
      display: none !important
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/messaging/messages.vue